import { createTheme } from "@mui/material";
import autocomplete from "@themes:overrides/autocomplete";
import button from "@themes:overrides/button";
import datagrid from "@themes:overrides/datagrid";
import select from "@themes:overrides/select";
import table from "@themes:overrides/table";
import textField from "@themes:overrides/textField";
import toggleButton from "@themes:overrides/toggleButton";
import toggleButtonGroup from "@themes:overrides/toggleButtonGroup";

import palette from "@:themes/palette";
import typography from "@:themes/typography";

export const themes = createTheme(
  {
    palette,
    typography,
  },
  {
    components: {
      ...button,
      ...textField,
      ...select,
      ...table,
      ...autocomplete,
      ...toggleButtonGroup,
      ...toggleButton,
      ...datagrid,
    },
  },
);
